define([
    'lodash'
], function (_) {
    'use strict';

    return {
        serialize: ({routers}) => {
            const routesConfigMap = _.get(routers, 'configMap', {});
            return {
                routers: Object.keys(routesConfigMap).reduce((accumulator, routeId) => Object.assign(accumulator, {
                    [routesConfigMap[routeId].prefix]: Object.assign({}, routesConfigMap[routeId], {routeId})
                }), {})
            };
        },
        deserialize: payload => ({
            rendererModel: {
                routers: {
                    configMap: Object.keys(payload.routers).reduce((acc, item) => _.merge(acc, 
                        {[payload.routers[item].routeId]: 
                            Object.assign({}, _.omit(payload.routers[item], 'routeId'), {prefix: item})}), {})
                }
            }
        }),
        getEncryptedPaths: payload => Object.keys(payload.routers).map(route => `routers.${route}`)
    };
});
